<template>
	<div class="notice_popup">
		<div class="close" @click="$emit('close')">
			<img src="/images/close.png" alt="닫기">
		</div>
		<div class="tit">배너 삭제</div>
		<div class="member">
			<span v-if="list.length > 0">‘{{list[0].bannerNm}}’<template v-if="list.length > 1">외 {{list.length - 1}}개</template></span><br>
			배너를 삭제 하시겠습니까?
		</div>
		<div class="select-btn">
			<div class="btn" @click="$emit('close')">취소</div>
			<div class="btn" @click="send()">예</div> 
		</div>
	</div>
</template>
<script>

export default {
	props: { param:Object },
	data() {
		return {
			list: this.param.list,
		};
	},
	beforeMount(){
		if(!Array.isArray(this.param.list) || this.param.list.length == 0){
			alert('배너정보를 확인 할 수 없습니다.');
			this.$emit('close');
		}
	},
	methods: {
		send(){
			this.$.httpPost('/api/main/bnr/delete', {list : this.list})
				.then(() => {
					alert('배너 삭제를 완료하였습니다.');
					this.$emit('close', true);
				}).catch(this.$.httpErrorCommon);
		}
	},
};
</script>
